import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
import { Box } from '@mui/material';

const Page = forwardRef(({ children, title = '', meta, ...other }, ref) => {
  const domain = window.location.origin;

  const siteName = (() => {
    switch (domain) {
      case 'https://panel.zibafood.ir':
      case 'https://panel.zibafood.com':
        return 'زیبا فود';
      case 'https://panel.qazvinfood.ir':
      case 'https://panel.qazvinfood.com':
        return 'قزوین فود';
      default:
        return 'قزوین فود';
    }
  })();

  return (
    <>
      <Helmet>
        <title>{`${title} | ${siteName}`}</title>
        {meta}
      </Helmet>

      <Box ref={ref} {...other}>
        {children}
      </Box>
    </>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
